/**
 * vet.ts — Categoría "Veterinaria" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_vet",
  skuPrefix: "VET",
  categoria: "Veterinaria",
} as const;

export const cat_vet_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Antipulgas Frontline Gato",
    marca: "Frontline",
    modelo: "Plus",
    origen: "Francia",
    costo: 28500,
    precio: 45000,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "pipeta",
    ubicacionFisica: "Vitrina V1, antiparasitarios",
    proveedor: "Boehringer Ingelheim",
    vencimientoMeses: 24,
    descripcionLarga:
      "Pipeta antipulgas y garrapatas para gatos adultos. Protección 1 mes. Fipronilo + S-metopreno.",
    especificaciones: [
      { clave: "Principio activo", valor: "Fipronilo + S-metopreno" },
      { clave: "Duración", valor: "1 mes" },
    ],
    imageKeywords: ["cat-flea-treatment", "pet-care", "frontline"],
    color: "bg-orange-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Desparasitante Drontal Perro",
    marca: "Drontal",
    modelo: "Plus Sabor",
    origen: "Alemania",
    costo: 18500,
    precio: 29500,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "tableta",
    ubicacionFisica: "Vitrina V1, antiparasitarios",
    proveedor: "Bayer Animal Health",
    vencimientoMeses: 36,
    descripcionLarga:
      "Desparasitante interno para perros, amplio espectro contra nematodos y cestodos. Sabor agradable.",
    especificaciones: [
      { clave: "Peso tratado", valor: "Hasta 10kg" },
      { clave: "Frecuencia", valor: "Cada 3 meses" },
    ],
    imageKeywords: ["dog-dewormer", "pet-medicine", "drontal"],
    color: "bg-amber-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Shampoo Antipulgas Perro 500ml",
    marca: "Vetnova",
    origen: "España",
    costo: 16500,
    precio: 26500,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "botella",
    ubicacionFisica: "Estante V2",
    proveedor: "Vetnova Health",
    vencimientoMeses: 36,
    pesoNeto: "500ml",
    descripcionLarga:
      "Shampoo medicado con permetrina, elimina pulgas y garrapatas mientras limpia e hidrata el pelaje del perro.",
    especificaciones: [
      { clave: "Volumen", valor: "500ml" },
      { clave: "Activo", valor: "Permetrina" },
    ],
    imageKeywords: ["dog-shampoo", "pet-grooming", "flea-shampoo"],
    color: "bg-green-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Collar Antipulgas Seresto",
    marca: "Seresto",
    origen: "Alemania",
    costo: 85000,
    precio: 129000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Vitrina V1",
    proveedor: "Bayer Animal Health",
    garantia: "8 meses protección",
    descripcionLarga:
      "Collar antipulgas y garrapatas Seresto con liberación controlada. Protección hasta 8 meses. Resistente al agua.",
    especificaciones: [
      { clave: "Duración", valor: "8 meses" },
      { clave: "Resistente agua", valor: "Sí" },
    ],
    imageKeywords: ["flea-collar", "dog-collar", "seresto"],
    color: "bg-slate-700",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Vitaminas Multi para Perros x60",
    marca: "Pet-Tabs",
    origen: "EE.UU.",
    costo: 24500,
    precio: 38500,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "frasco",
    ubicacionFisica: "Estante V3, suplementos",
    proveedor: "Zoetis Colombia",
    vencimientoMeses: 24,
    descripcionLarga:
      "Multivitamínico masticable para perros adultos. 11 vitaminas + 8 minerales. Apoya energía, piel y sistema inmune.",
    especificaciones: [
      { clave: "Unidades", valor: "60 tabletas" },
      { clave: "Sabor", valor: "Hígado" },
    ],
    imageKeywords: ["dog-vitamins", "pet-supplement", "dog-health"],
    color: "bg-amber-600",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Suero Fisiológico Veterinario 250ml",
    marca: "Baxter Vet",
    origen: "Colombia",
    costo: 4500,
    precio: 7500,
    stock: 80,
    stockMinimo: 18,
    stockMaximo: 150,
    unidad: "bolsa",
    ubicacionFisica: "Estante V2",
    proveedor: "Baxter Colombia",
    vencimientoMeses: 24,
    descripcionLarga:
      "Solución salina estéril 0.9% para uso veterinario. Rehidratación, limpieza de heridas y ojos en mascotas.",
    especificaciones: [
      { clave: "Volumen", valor: "250ml" },
      { clave: "Concentración", valor: "0.9% NaCl" },
    ],
    imageKeywords: ["saline-solution", "veterinary", "pet-medical"],
    color: "bg-cyan-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Jeringa Veterinaria 20ml x10",
    marca: "BD",
    origen: "México",
    costo: 8500,
    precio: 13500,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "paquete",
    ubicacionFisica: "Estante V2",
    proveedor: "Becton Dickinson Colombia",
    vencimientoMeses: 60,
    descripcionLarga:
      "Jeringas veterinarias 20ml estériles con aguja 18G. Empaque individual, 10 unidades por paquete.",
    especificaciones: [
      { clave: "Volumen", valor: "20ml" },
      { clave: "Unidades", valor: "10" },
    ],
    imageKeywords: ["veterinary-syringe", "animal-health", "vet-tools"],
    color: "bg-slate-200",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Crema Cicatrizante Vetericyn 100ml",
    marca: "Vetericyn Plus",
    origen: "EE.UU.",
    costo: 32500,
    precio: 52500,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "tubo",
    ubicacionFisica: "Vitrina V1",
    proveedor: "Innovacyn Inc.",
    vencimientoMeses: 24,
    pesoNeto: "100ml",
    descripcionLarga:
      "Gel cicatrizante veterinario. Acelera recuperación de heridas, rasguños y quemaduras. Libre de antibióticos y esteroides.",
    especificaciones: [
      { clave: "Volumen", valor: "100ml" },
      { clave: "Uso", valor: "Heridas, quemaduras" },
    ],
    imageKeywords: ["veterinary-cream", "pet-wound-care", "healing-gel"],
    color: "bg-teal-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Antibiótico Amoxicilina Vet 100ml",
    marca: "Zoetis Vet",
    origen: "EE.UU.",
    costo: 38500,
    precio: 59500,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "frasco",
    ubicacionFisica: "Vitrina V1 refrigerada",
    proveedor: "Zoetis Colombia",
    vencimientoMeses: 18,
    pesoNeto: "100ml",
    descripcionLarga:
      "Amoxicilina inyectable 15% uso veterinario. Antibiótico de amplio espectro para infecciones bacterianas en perros y gatos.",
    especificaciones: [
      { clave: "Concentración", valor: "15%" },
      { clave: "Volumen", valor: "100ml" },
    ],
    imageKeywords: ["veterinary-antibiotic", "amoxicillin-vet", "pet-medicine"],
    color: "bg-white",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Cepillo Dental para Perros",
    marca: "Virbac",
    modelo: "CET Dual End",
    origen: "Francia",
    costo: 12500,
    precio: 19900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Estante V3",
    proveedor: "Virbac Colombia",
    material: "Nylon suave",
    descripcionLarga:
      "Cepillo dental doble cabeza para razas pequeñas y medianas. Cerdas suaves especiales para encías caninas.",
    especificaciones: [
      { clave: "Tipo", valor: "Doble cabeza" },
      { clave: "Cerda", valor: "Suave nylon" },
    ],
    imageKeywords: ["dog-toothbrush", "pet-dental", "canine-hygiene"],
    color: "bg-blue-300",
    shape: "square",
  }),
];
